import React from 'react';

const CustomLoginPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/login',
			exact: true,
			component: React.lazy(() => import('./CustomLoginPage')),
		},
	],
};

export default CustomLoginPageConfig;
